import styles from './index.module.scss';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import screen4Background from '@/assets/productCenter/ai/ai-screen4-background.png';
import screen4FiguresPhoneBg from '@/assets/productCenter/ai/ai-screen4-figures-phone-bg.png';
import screen4Figures from '@/assets/productCenter/ai/ai-screen4-figures.png';
import screen4VerticalBg from '@/assets/productCenter/ai/ai-screen4-vertical-bg.png';
import screen4LeftTop from '@/assets/productCenter/ai/ai-screen4-left-top.png';
import screen4LeftBottom from '@/assets/productCenter/ai/ai-screen4-left-bottom.png';
import screen4Right from '@/assets/productCenter/ai/ai-screen4-right.png';

export default function Screen4() {
  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 0.8,
    animationClassName: styles['screen4-anim-start'],
    scrollContainerSelector: null,
  });

  return (
    <section
      ref={slideInRef.ref}
      className={styles['screen4-cover']}
      style={{ '--background4-url': `url(${screen4Background})` } as React.CSSProperties}
    >
      <div className={styles['screen-top-content']}>
        <div className={styles['screen-top-title']}>全自研多场景数字人</div>
        <div className={styles['screen-top-desc']}>
          融合多模态感知与智能语音交互能力，创造革命性的AI互动体验
        </div>
      </div>

      <div className={styles['screen4-container']}>
        <div className={styles['screen4-vertical-bg-wrap']}>
          <div className={styles['screen4-vertical-bg-track']}>
            <img src={screen4VerticalBg} alt="" className={styles['screen4-vertical-bg-slide']} loading="lazy" />
            <img src={screen4VerticalBg} alt="" className={styles['screen4-vertical-bg-slide']} loading="lazy" />
            <img src={screen4VerticalBg} alt="" className={styles['screen4-vertical-bg-slide']} loading="lazy" />
            <img src={screen4VerticalBg} alt="" className={styles['screen4-vertical-bg-slide']} loading="lazy" />
          </div>
        </div>
        <img
          src={screen4FiguresPhoneBg}
          alt="screen4-image"
          className={styles['screen4-figures-phone-bg']}
          loading="lazy"
        />
        <img src={screen4Figures} alt="screen4-image" className={styles['screen4-figures']} loading="lazy" />
        <div className={styles['screen4-left-block-wrap']}>
          <div className={styles['screen4-left-block']}>
            <div className={styles['screen4-left-block-title']}>多场景智能内容生成</div>
            <div className={styles['screen4-card-desc']}>
              在多个场景下实时生成个性化内容，灵活适配用户反馈，强化学习效果与体验
            </div>
          </div>
          <img src={screen4LeftTop} alt="" className={styles['screen4-card-img-top']} loading="lazy" />
        </div>
        <div className={styles['screen4-left-bottom-block-wrap']}>
          <div className={styles['screen4-left-block']}>
            <div className={styles['screen4-left-block-title']}>极致的拟真教学沟通</div>
            <div className={styles['screen4-card-desc']}>
              运用多情感TTS及跨语言技术，提供真实、无障碍的教学沟通体验
            </div>
          </div>
          <img src={screen4LeftBottom} alt="" className={styles['screen4-card-img-bottom']} loading="lazy" />
        </div>
        <div className={styles['screen4-right-block-wrap']}>
          <div className={styles['screen4-left-block']}>
            <div className={styles['screen4-left-block-title']}>多模态感知能力</div>
            <div className={styles['screen4-card-desc']}>
              通过情绪、姿态识别提供情感化的互动体验，增加用户的参与感
            </div>
          </div>
          <img src={screen4Right} alt="" className={styles['screen4-card-img-right']} loading="lazy" />
        </div>
      </div>
    </section>
  );
}
